import bbox from '@turf/bbox'
import * as turf from '@turf/turf'
import { Feature, MultiPolygon, Polygon } from '@turf/helpers'

type Props = {
  name: string
}

export const austinCenterPoint = [-97.7383476477957, 30.237621629711796]

export const continentalUnitedStates: Feature<Polygon, Props> = {
  type: 'Feature',
  properties: {
    name: 'continental-united-states',
  },
  geometry: {
    type: 'Polygon',
    coordinates: [
      [
        [-123.24462890625, 49.03786794532644],
        [-123.23364257812499, 48.31242790407178],
        [-124.74975585937501, 48.596592251456705],
        [-124.90356445312499, 48.40003249610685],
        [-124.23339843749999, 46.84516443029276],
        [-124.29931640625, 44.512176171071054],
        [-124.76074218749999, 42.90816007196054],
        [-124.178466796875, 41.376808565702355],
        [-124.85961914062501, 40.3130432088809],
        [-120.85235595703126, 34.34116826510752],
        [-119.5916748046875, 33.22949814144951],
        [-118.51226806640624, 32.778037985363675],
        [-117.20214843749999, 32.44488496716713],
        [-114.884033203125, 32.46342595776104],
        [-111.14868164062499, 31.297327991404266],
        [-108.17138671875, 31.287939892641734],
        [-108.12744140625, 31.71882222408327],
        [-106.490478515625, 31.70947636001935],
        [-105.062255859375, 30.56226095049944],
        [-104.578857421875, 29.506549442788593],
        [-103.095703125, 28.92163128242129],
        [-102.579345703125, 29.649868677972304],
        [-101.546630859375, 29.6880527498568],
        [-100.92041015625, 29.104176683949984],
        [-99.7998046875, 27.576460076262716],
        [-99.20654296875, 26.322960198925365],
        [-97.086181640625, 25.78999956287362],
        [-96.778564453125, 28.013801376380712],
        [-93.44970703125, 29.6880527498568],
        [-91.395263671875, 29.152161283318915],
        [-88.912353515625, 28.950475674848008],
        [-89.3408203125, 30.135626231134587],
        [-85.89111328125, 30.135626231134587],
        [-85.1220703125, 29.49698759653577],
        [-84.111328125, 30.050076521698735],
        [-82.760009765625, 28.85429649869795],
        [-83.03466796874999, 27.868216579514076],
        [-81.05712890625, 24.856534339310674],
        [-82.298583984375, 24.587090339209634],
        [-81.33041381835938, 24.261989400796306],
        [-80.0244140625, 25.423431426334222],
        [-79.991455078125, 27.068909095463365],
        [-81.287841796875, 30.911651004518244],
        [-78.673095703125, 33.458942753687644],
        [-75.16845703124999, 35.25459097465022],
        [-75.904541015625, 37.01132594307015],
        [-74.24560546875, 38.87179021382536],
        [-73.861083984375, 40.47202439692057],
        [-69.884033203125, 41.20345619205131],
        [-69.840087890625, 42.00032514831621],
        [-70.718994140625, 42.407234661551875],
        [-70.059814453125, 43.60426186809618],
        [-66.59774780273438, 44.629573191951046],
        [-67.73071289062499, 45.767522962149876],
        [-67.664794921875, 47.08508535995386],
        [-68.02734375, 47.42808726171425],
        [-69.2578125, 47.53203824675999],
        [-71.575927734375, 45.09679146394738],
        [-74.8828125, 45.10454630976873],
        [-76.22314453125, 44.41808794374846],
        [-76.79443359375, 43.739352079154706],
        [-78.673095703125, 43.76315996157264],
        [-79.310302734375, 43.50872101129684],
        [-79.0576171875, 42.88401467044253],
        [-82.46337890625, 41.77950486590359],
        [-83.023681640625, 41.94314874732696],
        [-82.825927734375, 42.23665188032057],
        [-82.06787109374999, 43.58039085560784],
        [-82.4853515625, 45.506346901083425],
        [-84.08935546875, 46.70973594407157],
        [-88.35205078124999, 48.42920055556841],
        [-91.62597656249999, 48.44377831058802],
        [-93.36181640625, 48.777912755501845],
        [-94.6142578125, 48.90805939965008],
        [-94.68017578125, 49.38237278700955],
        [-95.2294921875, 49.453842594330716],
        [-95.2734375, 49.10983779052439],
        [-123.24462890625, 49.03786794532644],
      ],
    ],
  },
}

export const centralAustin: Feature<Polygon, Props> = {
  type: 'Feature',
  properties: {
    name: 'central austin',
  },
  geometry: {
    type: 'Polygon',
    coordinates: [
      [
        [-97.73832321166992, 30.378502879007097],
        [-97.75531768798828, 30.337620704167275],
        [-97.77179718017578, 30.274338186666988],
        [-97.73780822753906, 30.257732732602136],
        [-97.70862579345703, 30.312875731719547],
        [-97.70038604736328, 30.339250393072167],
        [-97.71308898925781, 30.34784284954548],
        [-97.71909713745116, 30.369024476106393],
        [-97.73832321166992, 30.378502879007097],
      ],
    ],
  },
}

export const hawaii: Feature<Polygon, Props> = {
  type: 'Feature',
  geometry: {
    type: 'Polygon',
    coordinates: [
      [
        [-160.39, 21.74],
        [-160.07, 21.65],
        [-159.81, 21.9],
        [-159.49, 21.75],
        [-159.25, 21.82],
        [-158.39, 21.49],
        [-158.19, 21.22],
        [-157.69, 21.14],
        [-157.41, 21.03],
        [-157.12, 20.71],
        [-156.81, 20.46],
        [-156.6, 20.41],
        [-156.23, 20.47],
        [-156.05, 20.25],
        [-156.03, 20.03],
        [-156.14, 19.84],
        [-156.16, 19.67],
        [-156.09, 19.48],
        [-156.08, 19.29],
        [-156.08, 19.06],
        [-155.96, 18.89],
        [-155.81, 18.8],
        [-155.57, 18.72],
        [-155.36, 18.69],
        [-155.18, 18.69],
        [-155.0, 18.78],
        [-154.9, 18.92],
        [-154.78, 19.05],
        [-154.58, 19.15],
        [-154.47, 19.26],
        [-154.43, 19.42],
        [-154.48, 19.6],
        [-154.72, 19.76],
        [-154.87, 19.93],
        [-155.03, 20.14],
        [-155.34, 20.34],
        [-155.56, 20.46],
        [-155.71, 20.61],
        [-155.74, 20.78],
        [-155.82, 20.95],
        [-156.02, 21.07],
        [-156.29, 21.18],
        [-156.56, 21.3],
        [-156.84, 21.41],
        [-157.21, 21.44],
        [-157.46, 21.5],
        [-157.63, 21.69],
        [-157.86, 21.85],
        [-158.16, 21.84],
        [-158.35, 21.71],
        [-159.13, 21.96],
        [-159.15, 22.19],
        [-159.32, 22.35],
        [-159.63, 22.39],
        [-159.88, 22.23],
        [-160.15, 22.11],
        [-160.34, 21.99],
        [-160.39, 21.74],
      ],
    ],
  },
  properties: {
    name: 'hawaii',
  },
}

export const alaska: Feature<Polygon, Props> = {
  type: 'Feature',
  geometry: {
    type: 'Polygon',
    coordinates: [
      [
        [-140.7568359375, 69.7485511291223],
        [-156.31347656249997, 71.71198866923088],
        [-161.7626953125, 70.57611174177543],
        [-166.02539062499997, 69.23278913807921],
        [-174.6826171875, 60.53296819772097],
        [-159.1259765625, 58.205449994019915],
        [-176.1328125, 52.496159531097106],
        [-186.5478515625, 53.31774904749087],
        [-187.60253906249997, 53.34399288223422],
        [-187.22900390624997, 52.09300763963822],
        [-185.38330078125, 51.984880139916626],
        [-180.966796875, 51.2206474303833],
        [-176.22070312499997, 51.440312757160115],
        [-162.39990234375, 53.30462107510269],
        [-153.61083984374997, 56.17002298293205],
        [-148.99658203125, 59.45624336447568],
        [-140.16357421875, 59.16466752496466],
        [-136.07666015625, 56.76476752576022],
        [-134.7681640625, 53.56529883100152],
        [-130.46816406249997, 53.066066759438776],
        [-126.66816406249998, 55.562178094327585],
        [-134.1681640625, 60.85355302391582],
        [-140.55908203125, 60.65164736580915],
        [-140.77880859374997, 61.62728646147466],
        [-140.7568359375, 69.7485511291223],
      ],
    ],
  },
  properties: {
    name: 'alaska',
  },
}

export const VectorSquare = {
  continentalUnitedStates: bbox(continentalUnitedStates),
  hawaii: bbox(hawaii),
  alaska: bbox(alaska),
}

export const unitedStates: Feature<MultiPolygon, Props> = {
  type: 'Feature',
  properties: {
    name: 'USA',
  },
  geometry: {
    type: 'MultiPolygon',
    coordinates: [
      continentalUnitedStates.geometry.coordinates,
      alaska.geometry.coordinates,
      hawaii.geometry.coordinates,
    ],
  },
}

export const centralTexas: Feature<Polygon, Props> = {
  type: 'Feature',
  properties: {
    name: 'central-texas',
  },
  geometry: {
    type: 'Polygon',
    coordinates: [
      [
        [-97.470703125, 27.449790329784214],
        [-96.92138671875, 28.285033294640684],
        [-94.482421875, 29.649868677972304],
        [-94.6142578125, 33.394759218577995],
        [-98.349609375, 34.43409789359469],
        [-100.45898437499999, 32.58384932565662],
        [-100.01953125, 28.786918085420226],
        [-97.470703125, 27.449790329784214],
      ],
    ],
  },
}

export const austinMetro: Feature<Polygon, Props> = {
  type: 'Feature',
  properties: {
    name: 'austin-metro',
  },
  geometry: {
    type: 'Polygon',
    coordinates: [
      [
        [-97.61077880859375, 30.77723866322742],
        [-98.19305419921875, 30.524413269923986],
        [-98.10516357421874, 29.90256760730233],
        [-97.38830566406249, 29.852555290064018],
        [-97.10540771484375, 30.330212685432734],
        [-97.61077880859375, 30.77723866322742],
      ],
    ],
  },
}

export const sanFrancisco: Feature<Polygon, { name: string }> = {
  type: 'Feature',
  properties: { name: 'San Francisco' },
  geometry: {
    type: 'Polygon',
    coordinates: [
      [
        [-122.48863220214842, 37.79147283080962],
        [-122.51798629760742, 37.78713175115391],
        [-122.50837326049806, 37.69509519887689],
        [-122.38271713256835, 37.701614824548614],
        [-122.35147476196289, 37.729724141962045],
        [-122.36555099487303, 37.73746251604987],
        [-122.38271713256835, 37.787674400057654],
        [-122.4041748046875, 37.81222509298159],
        [-122.46408462524413, 37.80774960805068],
        [-122.47781753540039, 37.812903173094604],
        [-122.48863220214842, 37.79147283080962],
      ],
    ],
  },
}

export const saltLakeCity: Feature<Polygon, { name: string }> = {
  type: 'Feature',
  properties: {
    name: 'salt-lake-city',
  },
  geometry: {
    type: 'Polygon',
    coordinates: [
      [
        [-112.05848693847656, 40.4579195465031],
        [-111.79618835449219, 40.4579195465031],
        [-111.79618835449219, 40.833034570951135],
        [-112.05848693847656, 40.833034570951135],
        [-112.05848693847656, 40.4579195465031],
      ],
    ],
  },
}

export const anchorage = turf.circle([-149.9, 61.218], 40, { units: 'miles', properties: { name: 'Anchorage' } })
export const juneau = turf.circle([-134.42, 58.302], 30, { units: 'miles', properties: { name: 'Juneau' } })
export const fairbanks = turf.circle([-147.716, 64.838], 30, { units: 'miles', properties: { name: 'Fairbanks' } })

export const parcelCoveragePolygons: Feature<Polygon, Props>[] = [
  continentalUnitedStates,
  hawaii,
  anchorage,
  juneau,
  fairbanks,
]
